module.exports = __webpack_public_path__ + "img/tr-link.7691c611.png";